import PropTypes from 'prop-types'
import { Table, Tbody, Thead, Tr } from '@chakra-ui/react'
import { numberFormatter } from 'lib'
import { ThMetric, TdMetric } from './common'

export const MetricsPreProduction = ({ data }) => {
  return (
    <Table>
      <Thead>
        <Tr>
          <ThMetric w="7%">Department</ThMetric>
          <ThMetric w="7%">Sub Department</ThMetric>
          <ThMetric w="10%">Measure</ThMetric>
          <ThMetric w="10%">Unit of Measure</ThMetric>
          {data.dateHeaders.map(dateHeader => <ThMetric key={dateHeader.date}>{dateHeader.text}</ThMetric>)}
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <TdMetric rowSpan={30}>Pre Production</TdMetric>
          <TdMetric rowSpan={8}>Overall</TdMetric>
          <TdMetric rowSpan={2}>Total</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.overall.total.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.preproduction.overall.total.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>New Last 7 Days</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.overall.new.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.preproduction.overall.new.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>Out Last 7 Days</TdMetric>
          <TdMetric>Count #</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.overall.out.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Amount $</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{numberFormatter(dateHeader.preproduction.overall.out.amount)}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>Days in Pre-Production Last 25 deals</TdMetric>
          <TdMetric>Avg</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.overall.last.avg}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Median</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.overall.last.median}</TdMetric>)}
        </Tr>
        {/* <Tr>
          <TdMetric rowSpan={4}>Pre-Production Fallout Rate</TdMetric>
          <TdMetric>30 Days %</TdMetric>
          {data.dateHeaders.map(dateHeader => {
            return (
              <TdMetric key={dateHeader.date}>
                {dateHeader.preproduction.overall.fallout.newLast365 ? numberFormatter(dateHeader.preproduction.overall.fallout.days30 / dateHeader.preproduction.overall.fallout.newLast365 * 100, 1) : 0}%
              </TdMetric>
            )
          })}
        </Tr>
        <Tr>
          <TdMetric>60 Days %</TdMetric>
          {data.dateHeaders.map(dateHeader => {
            return (
              <TdMetric key={dateHeader.date}>
                {dateHeader.preproduction.overall.fallout.newLast365 ? numberFormatter(dateHeader.preproduction.overall.fallout.days60 / dateHeader.preproduction.overall.fallout.newLast365 * 100, 1) : 0}%
              </TdMetric>
            )
          })}
        </Tr>
        <Tr>
          <TdMetric>90 Days %</TdMetric>
          {data.dateHeaders.map(dateHeader => {
            return (
              <TdMetric key={dateHeader.date}>
                {dateHeader.preproduction.overall.fallout.newLast365 ? numberFormatter(dateHeader.preproduction.overall.fallout.days90 / dateHeader.preproduction.overall.fallout.newLast365 * 100, 1) : 0}%
              </TdMetric>
            )
          })}
        </Tr>
        <Tr>
          <TdMetric>12 Months %</TdMetric>
          {data.dateHeaders.map(dateHeader => {
            return (
              <TdMetric key={dateHeader.date}>
                {dateHeader.preproduction.overall.fallout.newLast365 ? numberFormatter(dateHeader.preproduction.overall.fallout.days365 / dateHeader.preproduction.overall.fallout.newLast365 * 100, 1) : 0}%
              </TdMetric>
            )
          })}
        </Tr> */}
        {/* Pre Production - Permitting */}
        <Tr>
          <TdMetric rowSpan={7}>Permitting</TdMetric>
          {/* <TdMetric>Total Working</TdMetric>
          <TdMetric>Count</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.permitting.total.count}</TdMetric>)} */}
        </Tr>
        <Tr>
          <TdMetric>Investigating # Days</TdMetric>
          <TdMetric>Average</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.permitting.investigating.avg}</TdMetric>)}
        </Tr>
        {/* <Tr>
          <TdMetric>Median</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.permitting.investigating.median}</TdMetric>)}
        </Tr> */}
        <Tr>
          <TdMetric>Permits Submitted</TdMetric>
          <TdMetric>Count</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.permitting.permitsSubmitted.count}</TdMetric>)}
        </Tr>
        {/* <Tr>
          <TdMetric rowSpan={2}>Submitted # Days</TdMetric>
          <TdMetric>Average</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.permitting.submittedDays.avg}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Median</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.permitting.submittedDays.median}</TdMetric>)}
        </Tr> */}
        <Tr>
          <TdMetric>{'Permit No Follow-up >7 days'}</TdMetric>
          <TdMetric>Count</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.permitting.permitNoFollowup.count}</TdMetric>)}
        </Tr>
        {/* <Tr>
          <TdMetric>Client Submitting</TdMetric>
          <TdMetric>Count</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.permitting.clientSubmitting.count}</TdMetric>)}
        </Tr> */}
        <Tr>
          <TdMetric>No Permit Required</TdMetric>
          <TdMetric>Count</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.permitting.notNeeded.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>Days to Receive Permit</TdMetric>
          <TdMetric>Average</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.permitting.daysToReceivePermit.avg}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Median</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.permitting.daysToReceivePermit.median}</TdMetric>)}
        </Tr>
        {/* <Tr>
          <TdMetric>Installer Pulling Permit</TdMetric>
          <TdMetric>Count</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.permitting.installerPullingPermit.count}</TdMetric>)}
        </Tr> */}
        {/* Pre-Production - Job Packets & Readiness */}
        <Tr>
          <TdMetric rowSpan={6}>Job Packets & Readiness</TdMetric>
          {/* <TdMetric>Total Working</TdMetric>
          <TdMetric>Count</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.jobpacket.total.count}</TdMetric>)} */}
        </Tr>
        <Tr>
          <TdMetric>Job Packets Completed last 7 days</TdMetric>
          <TdMetric>Count</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.jobpacket.last.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Pending Review</TdMetric>
          <TdMetric>Count</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.jobpacket.pendingReview.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Pending RFI</TdMetric>
          <TdMetric>Count</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.jobpacket.pendingRfi.count}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric rowSpan={2}>Days to Complete Job Packets</TdMetric>
          <TdMetric>Average</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.jobpacket.daysToComplete.avg}</TdMetric>)}
        </Tr>
        <Tr>
          <TdMetric>Median</TdMetric>
          {data.dateHeaders.map(dateHeader => <TdMetric key={dateHeader.date}>{dateHeader.preproduction.jobpacket.daysToComplete.median}</TdMetric>)}
        </Tr>
      </Tbody>
    </Table>
  )
}

MetricsPreProduction.propTypes = {
  data: PropTypes.object
}
